import { ActionType, ResourceType, useActionGuard } from '@hooks/useActionGuard';
import { constructPermissionResult } from '@hooks/useActionGuard/utils';

const EDIT_PERMISSION_MESSAGE =
  'Only organization admins and connections admins can perform this action.';

export const canCreateProfilesProject = () => {
  const { canPerformAction, isNewPermissionModelEnforcementEnabled } = useActionGuard();

  const permission = canPerformAction({
    old: { resourceType: 'workspace', action: 'edit' },
    new: {
      actionType: ActionType.CREATE,
      resource: { type: ResourceType.PROFILES_PROJECT },
    },
  });

  return isNewPermissionModelEnforcementEnabled
    ? permission
    : constructPermissionResult(permission.isAllowed, EDIT_PERMISSION_MESSAGE);
};

export const canDeleteProfilesProject = (projectId: string) => {
  const { canPerformAction, isNewPermissionModelEnforcementEnabled } = useActionGuard();

  const permission = canPerformAction({
    old: { resourceType: 'workspace', action: 'edit' },
    new: {
      actionType: ActionType.DELETE,
      resource: { type: ResourceType.PROFILES_PROJECT, id: projectId },
    },
  });

  return isNewPermissionModelEnforcementEnabled
    ? permission
    : constructPermissionResult(permission.isAllowed, EDIT_PERMISSION_MESSAGE);
};

export const canEditProfilesProject = (projectId: string) => {
  const { canPerformAction, isNewPermissionModelEnforcementEnabled } = useActionGuard();

  const permission = canPerformAction({
    old: { resourceType: 'workspace', action: 'edit' },
    new: {
      actionType: ActionType.EDIT,
      resource: { type: ResourceType.PROFILES_PROJECT, id: projectId },
    },
  });

  return isNewPermissionModelEnforcementEnabled
    ? permission
    : constructPermissionResult(permission.isAllowed, EDIT_PERMISSION_MESSAGE);
};
